module.exports = __webpack_public_path__ + "static/media/instagram-white.06c2d589.svg";